module.exports = __webpack_public_path__ + "img/slide-offer202402-dt-en.5ce26265.png";